import {
  SR_GET_USER_SETTINGS_REQUEST,
  SR_GET_USER_SETTINGS_SUCCESS,
  SR_POST_USER_SETTING_REQUEST,
  SR_POST_USER_SETTING_SUCCESS,
  SR_PATCH_USER_SETTING_REQUEST,
  SR_PATCH_USER_SETTING_SUCCESS,
  SR_PATCH_USER_STATUS_REQUEST,
  SR_PATCH_USER_STATUS_SUCCESS,
  SR_RESET_USER_INPUT,
  SR_USER_SETTINGS_LOADING,
  SR_CHANGE_INPUT_VALUE,
  SR_ADD_INPUT_ERROR,
  SR_REMOVE_INPUT_ERROR,
  SR_RESET_INPUT_ERROR,
  SR_INITIALIZE_USER_INPUT,
} from '../actionConstants/swapReinvestmentConstants';

export const getSwapInvestmentUserSettingsRequest = ({ serviceId } = {}) => ({
  type: SR_GET_USER_SETTINGS_REQUEST,
  payload: { serviceId },
});
export const getSwapInvestmentUserSettingsSuccess = ({ userSettings } = {}) => ({
  type: SR_GET_USER_SETTINGS_SUCCESS,
  payload: { userSettings },
});

export const createSwapInvestmentUserSettingRequest = ({
  status,
  instrumentId,
  side,
  quantity,
  amount,
  orderFrequency,
  rateLimit,
  quantityLimit,
  successCallback,
  failureCallback,
} = {}) => ({
  type: SR_POST_USER_SETTING_REQUEST,
  payload: {
    status,
    instrumentId,
    side,
    quantity,
    amount,
    orderFrequency,
    rateLimit,
    quantityLimit,
    successCallback,
    failureCallback,
  },
});

export const createSwapInvestmentUserSettingSuccess = ({ userSetting } = {}) => ({
  type: SR_POST_USER_SETTING_SUCCESS,
  payload: { userSetting },
});

export const updateSwapInvestmentUserSettingRequest = ({
  status,
  instrumentId,
  side,
  quantity,
  amount,
  orderFrequency,
  rateLimit,
  quantityLimit,
  successCallback,
  failureCallback,
} = {}) => ({
  type: SR_PATCH_USER_SETTING_REQUEST,
  payload: {
    status,
    instrumentId,
    side,
    quantity,
    amount,
    orderFrequency,
    rateLimit,
    quantityLimit,
    successCallback,
    failureCallback,
  },
});

export const updateSwapInvestmentUserSettingSuccess = ({ userSetting } = {}) => ({
  type: SR_PATCH_USER_SETTING_SUCCESS,
  payload: { userSetting },
});

export const updateSwapInvestmentUserStatusRequest = ({ status, instrumentId, side } = {}) => ({
  type: SR_PATCH_USER_STATUS_REQUEST,
  payload: {
    status,
    instrumentId,
    side,
  },
});

export const updateSwapInvestmentUserStatusSuccess = ({ userSetting } = {}) => ({
  type: SR_PATCH_USER_STATUS_SUCCESS,
  payload: {
    userSetting,
  },
});

export const resetSwapInvestmentUserInput = ({ input } = {}) => ({
  type: SR_RESET_USER_INPUT,
  payload: { input },
});

export const initializeSwapInvestmentUserInput = ({ instrumentId, side, successCallback, failureCallback } = {}) => ({
  type: SR_INITIALIZE_USER_INPUT,
  payload: { instrumentId, side, successCallback, failureCallback },
});

export const changeUserSettingLoading = ({ loading } = {}) => ({
  type: SR_USER_SETTINGS_LOADING,
  payload: { loading },
});

export const changeUserInputValue = ({ name, value } = {}) => ({
  type: SR_CHANGE_INPUT_VALUE,
  payload: { name, value },
});

export const addInputError = ({ name, error } = {}) => ({
  type: SR_ADD_INPUT_ERROR,
  payload: { name, error },
});

export const removeInputError = ({ name, error } = {}) => ({
  type: SR_REMOVE_INPUT_ERROR,
  payload: { name, error },
});

export const resetInputError = () => ({
  type: SR_RESET_INPUT_ERROR,
});
